import { AlertDialog, Box, Button, Callout, Card, Container, Flex, Heading, Text, TextField } from '@radix-ui/themes'
import { ArrowLeftIcon, EnvelopeClosedIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons'
import React, { FormEventHandler, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form } from 'radix-ui'

import useUserPasswordReq from '../hooks/useUserPasswordReq'

import { AppVersion } from '@/modules/app/components/AppVersion'
import { AppPath } from '@/enums/AppPath'

const UserPasswordReq: React.FC = () => {
  const { errorUserPasswordReq, loading, userPasswordReq } = useUserPasswordReq()
  const [dialogMessage, setDialogMessage] = useState('')
  const [dialogOpen, setDialogOpen] = useState(false)
  const [email, setEmail] = useState('')
  const navigate = useNavigate()

  const goToSignIn = () => navigate(`/${AppPath.Users}/sign-in`)

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault()

    const data = await userPasswordReq(email)

    setDialogMessage(typeof data === 'string' ? data : '')
    setDialogOpen(true)
  }

  return (
    <Flex flexGrow="1" justify="center" align="center">
      <Container size="1" pb="9">
        <Card>
          <Flex p="2" gap="4" direction="column">
            <Heading>Cambiar Clave</Heading>
            <Form.Root onSubmit={handleSubmit}>
              <Flex direction="column" gap="4">
                <Form.Field name="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control asChild>
                    <TextField.Root
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Ingresa tu email..."
                      disabled={loading}
                      value={email}
                      type="email"
                      id="email"
                      required
                    />
                  </Form.Control>
                  <Form.Message match="valueMissing">Por favor ingresa tu email.</Form.Message>
                  <Form.Message match="typeMismatch">Por favor ingresa un email válido.</Form.Message>
                </Form.Field>

                {errorUserPasswordReq && (
                  <Callout.Root color="red">
                    <Callout.Icon>
                      <ExclamationTriangleIcon />
                    </Callout.Icon>
                    <Callout.Text>{errorUserPasswordReq?.message}</Callout.Text>
                  </Callout.Root>
                )}

                <Button disabled={loading} loading={loading} type="submit">
                  <Text>Solicitar</Text>
                  <EnvelopeClosedIcon />
                </Button>
              </Flex>
            </Form.Root>

            <Button disabled={loading} variant="ghost" onClick={goToSignIn}>
              <Text>Cancelar</Text>
            </Button>
          </Flex>
        </Card>
        <AppVersion />
      </Container>

      <AlertDialog.Root open={dialogOpen}>
        <AlertDialog.Content>
          <AlertDialog.Title>¡Correo enviado!</AlertDialog.Title>

          {dialogMessage ? (
            <AlertDialog.Description>{dialogMessage}</AlertDialog.Description>
          ) : (
            <AlertDialog.Description>
              Te enviamos las instrucciones para restablecer tu clave. Revisa tu bandeja de entrada y, por si acaso, la
              carpeta de spam.
            </AlertDialog.Description>
          )}

          <Box mt="4">
            <AlertDialog.Action>
              <Button onClick={goToSignIn}>
                <ArrowLeftIcon />
                <Text>Volver al ingreso</Text>
              </Button>
            </AlertDialog.Action>
          </Box>
        </AlertDialog.Content>
      </AlertDialog.Root>
    </Flex>
  )
}

export default UserPasswordReq
